import InstagramGalleryService from "./InstagramGalleryService";

export default InstagramGalleryService;
